import React, { forwardRef, type Ref } from 'react';
import { useFieldProps } from '../../contexts/field-props-context';
import { type BaseFieldProps } from './base-field-props';
import { Field } from '../field';

interface BaseRequiredProps {
  asChild?: boolean;
  className?: string;
}

const BaseRequiredRoot = <T extends BaseFieldProps>(
  props: BaseRequiredProps,
  ref: Ref<HTMLDivElement>,
) => {
  const { required } = useFieldProps<T>();

  return <Field.Label.Required ref={ref} required={required} {...props} />;
};

export const BaseRequired = forwardRef(
  BaseRequiredRoot,
) as typeof BaseRequiredRoot;
